import clsx from 'clsx';
import Image from 'next/image';
import Link from 'next/link';
import React from 'react';
import Article from '~/data/strapi/types/collection-types/article';
import AppRoute from '~/enums/app-route';
import alt from '~/utils/default-alt';
import getDataPath from '~/utils/get-data-path';

import styles from './styles.module.css';

interface Props {
  article: Article;
  className?: string;
  isFirst?: boolean;
}

const ArticleCard: React.FC<Props> = ({ article, className, isFirst }) => {
  if (!article) return null;

  const { title, image, date, articleTags, slug } = article;

  return (
    <Link href={`/${AppRoute.BLOG}/${slug}`} className={clsx(styles.card, isFirst && styles.first, className)}>
      <div className={styles.imageWrapper}>
        {image && image.url && (
          <Image
            src={getDataPath(image.url)}
            alt={alt(image.alternativeText || title)}
            fill
            sizes="(max-width: 768px) 100vw, 25vw"
            className={styles.image}
          />
        )}
      </div>
      <div className={styles.content}>
        <div className={styles.tags}>
          {articleTags?.map((tag) => (
            <span key={tag.id} className={styles.tag}>
              {tag.title}
            </span>
          ))}
        </div>
        <h3 className={styles.articleTitle}>{title}</h3>
        <span className={styles.date}>{date && new Intl.DateTimeFormat('ru-RU').format(new Date(date))}</span>
      </div>
    </Link>
  );
};

export default ArticleCard;
